module.exports = __webpack_public_path__ + "static/media/mind-share.8a022d42.svg";